document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth < 1100) {  
        //variables
        const titleMenu = document.querySelectorAll('.container-menus .container-menu .moret');

        // recorre todo title_menu y agrega el evento click busca a su hermano calcula la altura y lo muestra, si ya esta abierto lo cierra. tambien le añades una clase active al padre
        titleMenu.forEach(function(item) {
            const handler = function() {
                const parent = this.parentElement;
                const submenu = this.nextElementSibling;
                if (!submenu) return;
                const height = submenu.scrollHeight;
                const parentActive = parent.classList.contains('active');

                if (parentActive) {
                    parent.classList.remove('active');
                    submenu.style.height = 0;
                } else {
                    parent.classList.add('active');
                    submenu.style.height = height + 'px';
                }
            };
            item.addEventListener('click', handler);
            item.addEventListener('touchstart', handler, { passive: true });
        });
    }  
});